import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useAuth } from '../../../context/AuthContext';
import { useNavigate } from "react-router-dom";
import contactService from '../../../services/contactService';
import { ContactDto } from '../../../types/crm/types/contact';
import ContactsHeader from "../../../components/crm/contact/ContactsHeader";
import ContactsTable from "../../../components/crm/contact/ContactsTable";
import CustomAppBar from "../../../components/shared/CustomAppBar";
import { CustomDrawer } from "../../../components/shared/CustomDrawer";

const ContactsPage: React.FC = () => {
  const [contacts, setContacts] = useState<ContactDto[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [searchText, setSearchText] = useState("");
  const { userToken } = useAuth();
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState<number | null>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);

  const activeProfile = userToken?.user.profiles.find(profile => profile.roleId === 3);

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        setLoading(true);
        const userProfileId = activeProfile?.id;

        console.log("Active Profile ID:", activeProfile);

        if (!userProfileId) {
          throw new Error("No se encontró el perfil activo");
        }

        const data = await contactService.getUserContacts(userProfileId);
        setContacts(data);
        setError(null);
      } catch (err: any) {
        setError(err.message || "Error al cargar los contactos");
      } finally {
        setLoading(false);
      }
    };

    fetchContacts();
  }, [activeProfile]);

  const filteredContacts = contacts.filter((contact) => {
    if (!searchText) return true;
    return (
      contact.fullName?.toLowerCase().includes(searchText.toLowerCase()) ||
      contact.contactType?.toLowerCase().includes(searchText.toLowerCase()) ||
      contact.email?.toLowerCase().includes(searchText.toLowerCase()) ||
      contact.phone?.toLowerCase().includes(searchText.toLowerCase()) ||
      contact.address?.toLowerCase().includes(searchText.toLowerCase())
    );
  });

  const handleRowClick = (contactId: number) => {
    setSelectedRow(contactId);
    navigate(`${contactId}`);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
    <CustomDrawer>
      <CustomAppBar />
      <Box sx={{ px: 4, py: 2, height: "100%", display: "flex", flexDirection: "column", mt: "10vh",
        width: `90%` 
       }}>
        <ContactsHeader
          searchText={searchText}
          onSearchChange={setSearchText}
          onAddContact={() => navigate('create')}
        />
      
      <ContactsTable
        contacts={filteredContacts}
        loading={loading}
        error={error}
        selectedRow={selectedRow}
        page={page}
        rowsPerPage={rowsPerPage}
        onRowClick={handleRowClick}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
    </CustomDrawer>
    </>
  );
};

export default ContactsPage;